import React, { useState } from "react"
import { Menu, MenuItem, IconButton } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSquareRss } from "@fortawesome/pro-regular-svg-icons"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { useMerchant } from "../../../../merchants/merchantHooks"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { fetchMenusList, MenuPlaningQuery, MenusListResponse } from "../menuPlanningApi"

const selectExternalFeeds = (data: MenusListResponse) => {
    return data?.menuPlanning?.externalFeeds
}

export function WeekMenuButton() {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
    const { merchantId } = useMerchant()

    const menuPlanningResult = useApiQuery(fetchMenusList, {
        queryName: MenuPlaningQuery.LIST,
        dependencies: {
            merchantId,
        },
        select: selectExternalFeeds,
    })

    const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleMenuClose = () => {
        setAnchorEl(null)
    }

    const openFeed = (type: "RSS" | "ATOM") => {
        const feed = menuPlanningResult?.data?.find((feed) => feed.type === type)
        if (feed?.url) {
            window.open(feed.url, "_blank")
        } else {
            console.error(`No URL found for ${type} feed`)
        }
    }

    return (
        <>
            <IconButton onClick={(e) => handleMenuOpen(e)}>
                <FontAwesomeIcon icon={faSquareRss} color="black" size="xl" />
            </IconButton>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <LocalizedStrict id="merchant-menu-planning-table-week-menu-rss-button">
                    <MenuItem
                        onClick={() => {
                            openFeed("RSS")
                            handleMenuClose()
                        }}
                    >
                        Week menu as RSS
                    </MenuItem>
                </LocalizedStrict>
                <LocalizedStrict id="merchant-menu-planning-table-week-menu-atom-button">
                    <MenuItem
                        onClick={() => {
                            openFeed("ATOM")
                            handleMenuClose()
                        }}
                    >
                        Week menu as Atom
                    </MenuItem>
                </LocalizedStrict>
            </Menu>
        </>
    )
}
